// Centroïdes ISO 3166-1 alpha-2 (lowercase) → [longitude, latitude]
// Source agrégée : Natural Earth + Wikipedia coordinates centroids
// Utilisé pour positionner les marqueurs Matomo sur la carte visiteurs.
const COUNTRY_CENTROIDS = {
  af: [66.0, 33.8], al: [20.0, 41.0], dz: [3.0, 28.0], as: [-170.7, -14.3],
  ad: [1.5, 42.5], ao: [17.5, -12.5], ai: [-63.0, 18.2], aq: [0.0, -90.0],
  ag: [-61.8, 17.1], ar: [-65.0, -35.0], am: [45.0, 40.0], aw: [-69.9, 12.5],
  au: [134.0, -25.0], at: [13.3, 47.3], az: [47.5, 40.5], bs: [-77.4, 24.3],
  bh: [50.6, 26.0], bd: [90.0, 24.0], bb: [-59.5, 13.2], by: [28.0, 53.0],
  be: [4.5, 50.5], bz: [-88.8, 17.2], bj: [2.3, 9.5], bm: [-64.8, 32.3],
  bt: [90.4, 27.5], bo: [-65.0, -17.0], ba: [18.0, 44.0], bw: [24.0, -22.0],
  br: [-55.0, -10.0], io: [71.5, -6.0], bn: [114.7, 4.5], bg: [25.0, 43.0],
  bf: [-2.0, 12.3], bi: [30.0, -3.5], kh: [105.0, 13.0], cm: [12.0, 6.0],
  ca: [-95.0, 60.0], cv: [-24.0, 16.0], ky: [-80.5, 19.5], cf: [21.0, 7.0],
  td: [19.0, 15.0], cl: [-71.0, -30.0], cn: [105.0, 35.0], co: [-72.0, 4.0],
  km: [44.0, -12.2], cd: [25.0, 0.0], cg: [15.0, -1.0], ck: [-159.8, -21.2],
  cr: [-84.0, 10.0], ci: [-5.0, 8.0], hr: [15.5, 45.2], cu: [-77.8, 21.5],
  cy: [33.0, 35.0], cz: [15.5, 49.8], dk: [10.0, 56.0], dj: [42.5, 11.5],
  dm: [-61.3, 15.4], do: [-70.7, 19.0], ec: [-77.5, -1.5], eg: [30.0, 27.0],
  sv: [-89.0, 13.8], gq: [10.0, 1.7], er: [39.0, 15.0], ee: [25.0, 59.0],
  et: [38.0, 8.0], fk: [-59.0, -51.8], fo: [-7.0, 62.0], fj: [178.0, -18.0],
  fi: [26.0, 64.0], fr: [2.4, 46.6], gf: [-53.0, 4.0], pf: [-145.0, -16.0],
  ga: [11.8, -1.0], gm: [-16.5, 13.5], ge: [43.5, 42.0], de: [10.5, 51.2],
  gh: [-2.0, 8.0], gi: [-5.4, 36.1], gr: [22.0, 39.0], gl: [-42.0, 72.0],
  gd: [-61.7, 12.1], gp: [-61.6, 16.2], gu: [144.8, 13.4], gt: [-90.3, 15.5],
  gn: [-10.0, 11.0], gw: [-15.0, 12.0], gy: [-59.0, 5.0], ht: [-72.4, 19.0],
  hn: [-86.5, 15.0], hk: [114.2, 22.3], hu: [20.0, 47.0], is: [-18.5, 65.0],
  in: [78.0, 22.0], id: [120.0, -5.0], ir: [53.0, 32.0], iq: [44.0, 33.0],
  ie: [-8.0, 53.0], il: [34.8, 31.5], it: [12.8, 42.8], jm: [-77.5, 18.2],
  jp: [138.0, 36.0], jo: [36.0, 31.0], kz: [68.0, 48.0], ke: [38.0, 1.0],
  ki: [173.0, 1.4], kp: [127.0, 40.0], kr: [127.8, 36.5], kw: [47.7, 29.3],
  kg: [75.0, 41.0], la: [105.0, 18.0], lv: [25.0, 57.0], lb: [35.8, 33.8],
  ls: [28.5, -29.5], lr: [-9.5, 6.5], ly: [17.0, 27.0], li: [9.5, 47.2],
  lt: [24.0, 56.0], lu: [6.1, 49.8], mo: [113.5, 22.2], mk: [22.0, 41.8],
  mg: [47.0, -19.0], mw: [34.0, -13.5], my: [112.5, 2.5], mv: [73.0, 3.2],
  ml: [-4.0, 17.0], mt: [14.4, 35.9], mh: [171.0, 9.0], mq: [-61.0, 14.7],
  mr: [-12.0, 20.0], mu: [57.5, -20.3], yt: [45.2, -12.8], mx: [-102.0, 23.0],
  fm: [158.2, 6.9], md: [29.0, 47.0], mc: [7.4, 43.7], mn: [105.0, 46.0],
  me: [19.3, 42.7], ms: [-62.2, 16.7], ma: [-5.0, 32.0], mz: [35.0, -18.3],
  mm: [98.0, 22.0], na: [17.0, -22.0], nr: [166.9, -0.5], np: [84.0, 28.0],
  nl: [5.5, 52.2], nc: [165.5, -21.5], nz: [174.0, -41.0], ni: [-85.0, 13.0],
  ne: [8.0, 16.0], ng: [8.0, 10.0], nu: [-169.9, -19.0], no: [10.0, 62.0],
  om: [57.0, 21.0], pk: [70.0, 30.0], pw: [134.6, 7.5], ps: [35.2, 31.9],
  pa: [-80.0, 9.0], pg: [147.0, -6.0], py: [-58.0, -23.0], pe: [-76.0, -10.0],
  ph: [122.0, 13.0], pl: [20.0, 52.0], pt: [-8.0, 39.5], pr: [-66.5, 18.2],
  qa: [51.2, 25.3], re: [55.5, -21.1], ro: [25.0, 46.0], ru: [100.0, 60.0],
  rw: [30.0, -2.0], sh: [-5.7, -15.9], kn: [-62.7, 17.3], lc: [-61.0, 13.9],
  pm: [-56.3, 47.0], vc: [-61.2, 13.2], ws: [-172.3, -13.6], sm: [12.5, 43.9],
  st: [7.0, 1.0], sa: [45.0, 25.0], sn: [-14.0, 14.0], rs: [21.0, 44.0],
  sc: [55.5, -4.6], sl: [-11.5, 8.5], sg: [103.8, 1.3], sk: [19.5, 48.7],
  si: [15.0, 46.0], sb: [159.0, -8.0], so: [46.0, 5.0], za: [25.0, -29.0],
  ss: [30.0, 8.0], es: [-3.7, 40.0], lk: [81.0, 7.0], sd: [30.0, 15.0],
  sr: [-56.0, 4.0], sz: [31.5, -26.5], se: [15.0, 62.0], ch: [8.0, 47.0],
  sy: [38.0, 35.0], tw: [121.0, 23.5], tj: [71.0, 39.0], tz: [35.0, -6.0],
  th: [100.0, 15.0], tl: [125.5, -8.8], tg: [1.2, 8.0], to: [-175.2, -20.0],
  tt: [-61.3, 11.0], tn: [9.0, 34.0], tr: [35.0, 39.0], tm: [60.0, 40.0],
  tc: [-71.6, 21.8], tv: [178.0, -8.0], ug: [32.5, 1.0], ua: [32.0, 49.0],
  ae: [54.0, 24.0], gb: [-2.0, 54.0], us: [-97.0, 38.0], uy: [-56.0, -33.0],
  uz: [64.0, 41.0], vu: [167.0, -16.0], va: [12.5, 41.9], ve: [-66.0, 8.0],
  vn: [108.0, 16.0], vg: [-64.6, 18.4], vi: [-64.8, 18.3], ye: [48.0, 15.5],
  zm: [27.0, -15.0], zw: [30.0, -19.0]
}

export default COUNTRY_CENTROIDS
